{
  "version": "v4.3.0",
  "name": "Tick",
  "bytecode": "0706405140a340f5410b416541730100030601402ad344ba8eddb4ce00451343217ba000170316033f16011f1704160405291343237b16043d170516051600321343227b1605a10016024c04a0011601204a03a00116011fa10116050c2f0201000405034032d3cfc5e9a41600ce01294c05a002a003a004024a40280c170416040f314c1e16047a0f314d0d2a7816047a0f314d0e2ac32b16047a0f314d0d2a7916040d2a17044a7fde1601160216030201000405034032d36efb0f181600ce01264c05a002a003a004024a40280c170416040f314c1e16047a0f314d0d2a7816047a0f314d0e2ac32b16047a0f314d0d2a7916040d2a17044a7fde16011602160302010201010008d3b0cd421fb4ce00451343217b1600b001000506014035d336cb1526b4ce00451343217b16034c03160417004a02160417010c170516050f314c1a16057a0f314d7816057a0f314d0e2ac32b16057a0f314d7916050d2a17054a22160016011602a104a103a102a00102010000000103d3602bc55da00102",
  "codeHash": "1373551ca890d886980b8d33277d7ed7a2c9f7665d77a1e893a1f2554d10d4b1",
  "fieldsSig": {
    "names": [
      "parent",
      "tick",
      "liquidityGross",
      "liquidityNet",
      "feeGrowthsOutside"
    ],
    "types": [
      "Address",
      "I256",
      "U256",
      "I256",
      "[U256;3]"
    ],
    "isMutable": [
      false,
      false,
      true,
      true,
      true
    ]
  },
  "eventsSig": [],
  "functions": [
    {
      "name": "update",
      "paramNames": [
        "maxLiquidity",
        "liquidityDelta",
        "upper"
      ],
      "paramTypes": [
        "U256",
        "I256",
        "Bool"
      ],
      "paramIsMutable": [
        false,
        false,
        false
      ],
      "returnTypes": [
        "Bool"
      ]
    },
    {
      "name": "feeGrowthBelow",
      "paramNames": [
        "tickCurrent",
        "globalGrowths"
      ],
      "paramTypes": [
        "I256",
        "[U256;3]"
      ],
      "paramIsMutable": [
        false,
        true
      ],
      "returnTypes": [
        "[U256;3]"
      ]
    },
    {
      "name": "feeGrowthAbove",
      "paramNames": [
        "tickCurrent",
        "globalGrowths"
      ],
      "paramTypes": [
        "I256",
        "[U256;3]"
      ],
      "paramIsMutable": [
        false,
        true
      ],
      "returnTypes": [
        "[U256;3]"
      ]
    },
    {
      "name": "clear",
      "paramNames": [
        "payer"
      ],
      "paramTypes": [
        "Address"
      ],
      "paramIsMutable": [
        false
      ],
      "returnTypes": []
    },
    {
      "name": "cross",
      "paramNames": [
        "globalGrowths",
        "zeroForOne",
        "feeGrowthGlobalX128"
      ],
      "paramTypes": [
        "[U256;3]",
        "Bool",
        "U256"
      ],
      "paramIsMutable": [
        true,
        false,
        false
      ],
      "returnTypes": [
        "I256"
      ]
    },
    {
      "name": "getLiquidityNet",
      "paramNames": [],
      "paramTypes": [],
      "paramIsMutable": [],
      "returnTypes": [
        "I256"
      ]
    }
  ],
  "constants": [],
  "enums": [
    {
      "name": "TickError",
      "fields": [
        {
          "name": "NotParent",
          "value": {
            "type": "U256",
            "value": "801"
          }
        },
        {
          "name": "LO",
          "value": {
            "type": "U256",
            "value": "802"
          }
        },
        {
          "name": "LS",
          "value": {
            "type": "U256",
            "value": "803"
          }
        }
      ]
    }
  ]
}